export const config = {
  isMockServerOn: false,
};
